import { useState } from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import LoadingButton from "@mui/lab/LoadingButton";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import Alert from "@mui/material/Alert";
import Divider from "@mui/material/Divider";

import PhoneNumbersPreview from "../components/PhoneNumbersPreview";
import MessageContentPreview from "../components/MessageContentPreview";

type ModalProps = {
	open: boolean;
	handleClose: () => void;
};

const InvalidAccountModal = ({ open, handleClose }: ModalProps) => {
	const style = {
		position: "absolute" as "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		width: "25%",
		boxShadow: 24,
		p: 4,
	};

	return (
		<Modal open={open} onClose={handleClose}>
			<Card sx={style}>
				<Typography variant='h5' sx={{ mb: 1 }}>
					Sorry
				</Typography>

				<Typography variant='body1' sx={{ mb: 3 }}>
					We are unable to proceed with your campaign for the moment due to your
					account not being in good standing.
				</Typography>

				<Stack direction='row' spacing={1}>
					<Button variant='outlined' onClick={handleClose}>
						Dismiss
					</Button>
					<Button variant='contained' href='https://app.messageflow.co'>
						Log in
					</Button>
				</Stack>
			</Card>
		</Modal>
	);
};

interface Props {
	phones: string[];
	message: string;
	goBack: () => void;
	sendMessage: (numbers: string[]) => void;
	loading: boolean;
	error: string;
	imageAttachment?: string;
}

const Review = ({
	phones,
	message,
	goBack,
	sendMessage,
	loading,
	error,
	imageAttachment,
}: Props) => {
	// @ts-ignore
	const { isValidAccount } = window.adminUiAppContext || {};

	const [openModal, setOpenModal] = useState(false);

	return (
		<Box sx={{ p: 1.5 }}>
			<Box
				sx={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
				{Boolean(error.length) ? (
					<Alert severity='error' sx={{ width: "100%", mb: 2 }}>
						{error}
					</Alert>
				) : null}
				<Box sx={{ display: "flex", alignItems: "start", width: "100%" }}>
					<PhoneNumbersPreview phones={phones} />

					<Divider orientation='vertical' flexItem sx={{ mr: 2, ml: 2 }} />

					<MessageContentPreview
						message={message}
						imageAttachment={imageAttachment}
					/>
				</Box>
			</Box>
			<Box sx={{ mt: 2 }}>
				<LoadingButton
					loading={loading}
					variant='contained'
					sx={{ mt: 1, mr: 1 }}
					onClick={() =>
						isValidAccount ? sendMessage(phones) : setOpenModal(true)
					}>
					Send Message
				</LoadingButton>
				<Button sx={{ mt: 1, mr: 1 }} onClick={goBack} disabled={loading}>
					Back
				</Button>
			</Box>

			<InvalidAccountModal
				open={openModal}
				handleClose={() => setOpenModal(false)}
			/>
		</Box>
	);
};

export default Review;
